import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Text, Flex, getPaletteColor } from 'pcln-design-system'
import { Modal, SmallModalHeader, ScrollLock } from 'pcln-modal'
import ModalContent from './ModalContent'

const CompareWrapper = styled(Flex)`
  padding-top: 16px;
  width: 100%;
`

const CompareText = styled(Text)`
  cursor: pointer;
  text-align: center;
  background-color: Transparent;
  border: none;
  font-size: 12px;
  color: ${getPaletteColor('primary.base')};
`

function CompareOptionsModal(props) {
  const {
    upsells,
    onClick,
    flyGaLogic,
    isFused,
    isMultiUpsell,
    baseFareToken,
    upsellToken,
    callToDetails,
  } = props

  const [infoModalOpen, setInfoModalOpen] = useState(false)
  const [scrollLock] = useState(new ScrollLock())

  const modalWidth = upsells.length > 1 ? '690px' : '400px'

  const toggleInfoModal = () => (e) => {
    // Since this can be used in a parent that also has an onClick event, we need to prevent
    // this event from bubbling up
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }

    if (infoModalOpen) {
      scrollLock.off()
      flyGaLogic.fireGtm(
        'send',
        'event',
        'MFLY-Listings',
        'Branded Fare Shelf Interaction',
        'COMPARE_OPTIONS_MODAL_CLOSE'
      )
    } else {
      scrollLock.on()
      if (typeof onClick === 'function') {
        onClick()
      }
      flyGaLogic.fireGtm(
        'send',
        'event',
        'MFLY-Listings',
        'Branded Fare Shelf Interaction',
        'COMPARE_OPTIONS_MODAL_OPEN'
      )
    }

    setInfoModalOpen(!infoModalOpen)
  }

  return (
    <CompareWrapper
      data-autobot-element='farebrand-compare-link'
      alignItems='flex-start'
      justifyContent='center'
      isMultiUpsell={isMultiUpsell}
      onClick={toggleInfoModal()}
    >
      <Box>
        <Modal
          data-autobot-element='itin-modal'
          isOpen={infoModalOpen}
          width={[modalWidth]}
          disableCloseButton={false}
          enableOverflow
          onClose={toggleInfoModal()}
          header={<SmallModalHeader bg={'primary.base'} />}
        >
          <ModalContent
            callToDetails={callToDetails}
            isFused={isFused}
            fareBrands={upsells}
            baseFareToken={baseFareToken}
            upsellToken={upsellToken}
          />
        </Modal>

        <CompareText fontSize={0}>What&apos;s included?</CompareText>
      </Box>
    </CompareWrapper>
  )
}

CompareOptionsModal.defaultProps = {
  upsells: [],
}

CompareOptionsModal.propTypes = {
  upsells: PropTypes.arrayOf(
    PropTypes.shape({
      brandAttributes: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string,
          description: PropTypes.string,
          inclusivity: PropTypes.string,
        })
      ),
      name: PropTypes.string,
      token: PropTypes.string,
      brandId: PropTypes.string,
      tier: PropTypes.number,
      price: PropTypes.number,
    })
  ),
  onClick: PropTypes.func,
  flyGaLogic: PropTypes.shape({
    fireGtm: PropTypes.func.isRequired,
  }).isRequired,
  isFused: PropTypes.bool,
  isMultiUpsell: PropTypes.bool,
  callToDetails: PropTypes.func,
  baseFareToken: PropTypes.string,
  upsellToken: PropTypes.string,
}

export default CompareOptionsModal
